<template>
  <div class="content" style="min-height: 100vh">
    <div
      class="background-image-search"
      style="background-image: url(/img/temp/blurred-dark.jpg"
    ></div>
    <!-- /.background-image-search -->

    <base-header class="header--recipe pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <h1>Edit Collection</h1>
      </b-row>
    </base-header>
    <b-container
      class="container--md mt--6"
    >
      <div class="add-recipe__container">
        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
      <form class="needs-validation"
            @submit.prevent="handleSubmit(firstFormSubmit)">
        <div class="form-row">
          <b-col md="12">
            <base-input label="Collection Name"
                        name="name"
                        type="textarea"
                        placeholder="Collection Name"
                        success-message="Looks good!"
                        rules="required"
                        v-model="model.title">
            </base-input>
          </b-col>
          <b-col md="12">
            <label class="form-control-label">
              Collection Description
            </label>
            <html-editor
              rules="required"
              v-model="model.description">
            </html-editor>
          </b-col>
          <b-col md="6">
             <div class="dropzone-header">
               <loading-panel v-show="loadingImage"></loading-panel>
                <vue2Dropzone
                  v-on:vdropzone-file-added="fileAdded"
                  v-on:vdropzone-max-files-exceeded="maxFilesExceeded"
                  id="mainImage"
                  :options="dropzoneOptions"
                  single
                  ref="mainImage"
                  v-show="!loadingImage"
                />
             </div>
          </b-col>
          <b-col md="6">
            <label class="form-control-label">
              Or choose a color
            </label>
            <div class="form__input color-picker">
              <v-swatches
                v-model="model.colorChoice"
                popover-x="right"
                popover-y="bottom"
                swatches="text-advanced"
              ></v-swatches>
            </div>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Active?
            </label><br />
            <base-switch label="Is Active?"
                    name="isActive"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isActive">
            </base-switch>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Featured?
            </label><br />
            <base-switch label="Is Featured?"
                    name="isFeatured"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isFeatured">
            </base-switch>
          </b-col>
          <b-col md="2">
            <label class="form-control-label">
              Public?
            </label><br />
            <base-switch label="Is Public?"
                    name="isPublic"
                    class="mr-1" 
                    on-text="Yes" 
                    off-text="No" 
                    v-model="model.isPublic">
            </base-switch>
          </b-col>
        </div>
        <base-button v-show="!loading" type="primary" native-type="submit">Save Collection</base-button>
         <base-button v-show="loading" type="primary" native-type="button">Please Wait <i class="fas fa-spinner fa-spin"></i></base-button>
        <base-button @click="handleDelete" v-if="isAdmin" type="warning" size="sm" class="edit" style="float: right" icon><i class="far fa-trash-alt"></i></base-button>
       
      </form>
    </validation-observer>
      </div>
    </b-container>
  </div>
</template>
<script>
  import { Select, Option } from 'element-ui'
  import HtmlEditor from '../../components/Inputs/HtmlEditor.vue';
  import Instructions from '../Components/Instructions.vue';
  import { authHeader } from '../../_helpers';
  import axios from 'axios'
  import "vue-swatches/dist/vue-swatches.css"
  import VSwatches from 'vue-swatches'
  import LoadingPanel from '../../components/LoadingPanel.vue';
  import vue2Dropzone from 'vue2-dropzone'
  import swal from 'sweetalert2'

  const apiClient = axios.create({
    baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/collections/`,
    withCredentials: false,
    headers: authHeader()
  })

  export default {
    name: "EditCollection",
    components: {
        HtmlEditor,
        vue2Dropzone,
        LoadingPanel,
        VSwatches,
        [Select.name]: Select,
        [Option.name]: Option,
        Instructions,
        swal
    },
    data() {
      return {
        model: {
          id: '',
          name: '',
          colorChoice: '',
          iconId: '0215cb06-0ebb-4b17-098d-08d9269dc513',
          icon: '',
          isFeatured: false,
          isActive: true,
          isPublic: true
        },
        loading: false,
        loadingImage: true,
        dropzoneOptions: {
          url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
          thumbnailWidth: 200,
          thumbnailHeight: 200,
          uploadMultiple: false,
          //previewsContainer: ".dropzone-previews",
          maxFiles: 1,
          maxFilesize: 256,
          maxThumbnailFilesize: 256,
          autoProcessQueue: false,
          addRemoveLinks: true,
          headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
        }
      }
    },
    methods: {
      firstFormSubmit() {
        const { dispatch } = this.$store;
        delete this.model.image;

        if ( this.$refs.mainImage.dropzone.files[0] ) {
          this.model.imageUpload = this.$refs.mainImage.dropzone.files[0]
        }

        if (this.model.title) {
          try {
              dispatch("collections/updateCollection", this.model)
                  .then(response => {
              }).catch(error => {
                  console.log('Something went wrong: ', error);
              });
          } catch (error) {
              console.log("Error: collection edit", error);
          }
        }
      },
      getCollection(id) {
        return apiClient.get(`${id}`);
      },
      loadCurrentImage() {
        if ( this.model.image && this.model.image.absoluteUri) {
          var mockFile = { name: this.model.image.name, size: 50000, type: 'image', id: this.model.image.id};
          this.$refs.mainImage.manuallyAddFile(mockFile, this.model.image.absoluteUri);
        } else {
          this.loadingImage = false;
        }
      },
      maxFilesExceeded(file) {
        this.$refs.mainImage.removeAllFiles()
        this.$refs.mainImage.addFile(file)
        this.model.mainImage = file
      },
      fileAdded(file) {
        this.model.mainImage = file
      },
      handleDelete() {
        swal.fire({
          title: 'DELETE COLLECTION?',
          text: `You won't be able to revert this!`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'Yes, delete it!',
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            const { dispatch } = this.$store;
            dispatch("collections/deleteCollection", { "collectionId": this.model.id });
            this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Collection Deleted'});
            this.$router.push({path: "/collections"});
          }
        });
      }
    },
    computed: {
      isAdmin() {
        return this.$store.getters.userIsAdmin
      },
      isLoading() {
        return this.$store.state.collections.loading
      }
    },
    created() {
      this.model.id = this.$route.params.id;
      this.getCollection(this.model.id)
        .then(response => {
          this.model = response.data;
        })
        .catch(error => {
          console.log(error)
        });
      setTimeout(() => {
        this.loadCurrentImage();
          this.loadingImage = false;
        }, 3600);
    },
    mounted() {
      
    },
    watch: {
      isLoading (newLoad) {
        if (newLoad == 'Saved') {
          this.$router.push({path: `/collections`});
          this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Collection Added'});
        }
        this.loading = newLoad
      }
    }
  }
</script>
<style>
.shortcut-item.add-collection{
  text-align: left;
  margin-bottom: 30px;
}
</style>
